module.exports = __webpack_public_path__ + "img/nobey.502f7ac4.svg";